const feeTypeMapper = {
  FLAT: "Flat Fee",
  JOB_SIZE: "Calculation of Job Size",
  JOB_COST: "Percent of Total Costs",
  MATERIALS: "Percent of Total Material Needed",
  JOB_LENGTH: "Multiple of Days on Job",
};
export default feeTypeMapper;
